module.exports = __webpack_public_path__ + "static/img/left_Down.01f42cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/left_Down.png?1
// module id = kLQ6
// module chunks = 1